import React, { ReactNode, useEffect, useRef, useState } from 'react'

import { Box, BoxProps, Flex, ScrollArea } from '@mantine/core'

import useStyles from './index.styles'
import flattenChildren from 'react-keyed-flatten-children'

type Props = BoxProps

export const ScrollAreaNav = ({
  children,
  className,
  styles,
  classNames,
  ...rest
}: Props) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'HealthToolsNav',
    styles,
    classNames,
  })
  const viewport = useRef<HTMLDivElement>(null)
  const [visibleSection, setVisibleSection] = useState('')

  useEffect(() => {
    const visibleEle = viewport.current?.querySelector(
      `[data-section-id="${visibleSection}"]`,
    )
    visibleEle instanceof HTMLElement &&
      viewport.current?.scrollTo({
        left: visibleEle.offsetLeft,
        behavior: 'smooth',
      })
  }, [visibleSection])

  return (
    <ScrollArea
      offsetScrollbars
      scrollbarSize={4}
      classNames={{
        viewport: classes.scrollViewport,
        thumb: classes.scrollThumb,
      }}
      viewportRef={viewport}
      {...rest}
    >
      <Flex className={cx(className, classes.root)} {...rest}>
        {flattenChildren(children).map((element: ReactNode, idx) => {
          if (React.isValidElement(element)) {
            return (
              <Box
                data-section-id={`scroll-${idx}`}
                key={idx}
                onClick={() => setVisibleSection(`scroll-${idx}`)}
              >
                {element}
              </Box>
            )
          }

          return null
        })}
      </Flex>
    </ScrollArea>
  )
}
